import { UploadSimple } from '@phosphor-icons/react'
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { Button } from '../../../../components/common/Button'
import { Input } from '../../../../components/common/Input'
import { Select } from '../../../../components/common/Select'
import { ContextContracts } from '../../../../context/context_contracts'
import {
  ButtonContainer,
  Container,
  Divider,
  PlaceHolderFile,
  Row,
  Section,
  TextAreaContainer,
  Title,
} from './styles'
interface ContractProps {
  created_by: string
  name: string
  version: string
  text: string
  type: string
}
interface FormNewResidentContractProps {
  handleModal: Dispatch<SetStateAction<boolean>>
}

export const FormNewResidentContract = ({
  handleModal,
}: FormNewResidentContractProps) => {
  const { createItem, updateFile } = useContext(ContextContracts)

  const [contractOption, setContractOption] = useState('')
  const [fileName, setFileName] = useState('Escolher arquivo')

  const userId = localStorage.getItem('id_user')

  const [contract, setContract] = useState<ContractProps>({
    created_by: userId || '',
    name: '',
    version: '',
    text: '',
    type: '',
  })

  const handleSelectChange = (value) => {
    setContractOption(value)
    setContract((prevItem) => ({
      ...prevItem,
      type: value,
    }))
  }

  const handleFileChange = (event) => {
    const fileInput = event.target
    if (fileInput.files.length > 0) {
      setFileName(fileInput.files[0].name)
    } else {
      setFileName('Escolher arquivo')
    }
  }

  const handleInputChange = (field, value) => {
    setContract((prevItem) => ({
      ...prevItem,
      [field]: value,
    }))
  }

  const currentDate = new Date()
  const dataFormatada =
    currentDate.getDate() +
    '/' +
    (currentDate.getMonth() + 1) +
    '/' +
    currentDate.getFullYear()

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    createItem(contract)
    toggleFunction(handleModal)
  }

  const contractWaysToSave = [
    { id: 'TEXT', value: 'Escrever contrato' },
    { id: 'FILE', value: 'Fazer upload' },
  ]

  console.log('🚀 ~ contract:', contract)
  return (
    <Container onSubmit={handleSubmit}>
      <Section>
        <Input.Root>
          <Input.Label
            title="Nome do contrato"
            htmlFor="newResidentContractName"
          />
          <Input.Wrapper>
            <Input.Content
              id="newResidentContName"
              type="text"
              value={contract.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              required
            />
          </Input.Wrapper>
        </Input.Root>
        <Row>
          {/* <Input.Root>
            <Input.Label
              title="Versão do contrato"
              htmlFor="newResidentContractVersion"
            />
            <Input.Wrapper>
              <Input.Content
                id="newResidentContractVersion"
                type="text"
                value={contract.version}
                onChange={(e) => handleInputChange('version', e.target.value)}
                required
              />
            </Input.Wrapper>
          </Input.Root> */}
          <Input.Root>
            <Input.Label
              title="Data de atualização"
              htmlFor="newResidentContractDate"
            />
            <Input.Wrapper>
              <Input.Content
                id="newResidentContractDate"
                type="text"
                value={'Dia da ação (' + dataFormatada + ')'}
                readOnly
                disabled
              />
            </Input.Wrapper>
          </Input.Root>
        </Row>
      </Section>
      <Divider />
      <Section>
        <Title>Texto do contrato</Title>
        <Select
          onchange={(e) => handleSelectChange(e.target.value)}
          label={{
            title: 'Como você deseja salvar o contrato?',
            htmlFor: '',
            color: '',
            fontSize: '12px',
          }}
          data={contractWaysToSave}
          backgroundcolor=""
          bordercolor="#CECECE"
          currentOption={contractOption}
          outlinecolor=""
        />
        {contractOption === 'FILE' ? (
          <Input.Root>
            <Input.Label
              title="Salvar contrato"
              htmlFor="newResidentContractName"
            />
            <Input.Wrapper>
              <PlaceHolderFile>{fileName}</PlaceHolderFile>
              <Input.Content
                id="newResidentContName"
                type="file"
                onChange={(e) => {
                  handleFileChange(e)
                  updateFile(e.target.files[0])
                }}
                required
                accept="application/pdf"
              />
              <Input.Icon>
                <UploadSimple size={24} />
              </Input.Icon>
            </Input.Wrapper>
          </Input.Root>
        ) : contractOption === 'TEXT' ? (
          <TextAreaContainer>
            <ReactQuill
              theme="snow"
              value={contract.text}
              onChange={(e) => handleInputChange('text', e)}
            />
          </TextAreaContainer>
        ) : null}
        <ButtonContainer>
          <Button.Root backgroundColor="#003E5F" type="submit">
            <Button.Content title="Salvar contrato" />
          </Button.Root>
        </ButtonContainer>
      </Section>
    </Container>
  )
}
